module.exports = __webpack_public_path__ + "static/bird-over-basin-e079e64aee5a8abfca72b3d081a6b8b0.jpg";